function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import bbobHTML from '@bbob/html';
import presetHTML5 from '@bbob/preset-html5';
export const getUniqAttr = attrs => Object.keys(attrs).reduce((_res, key) => attrs[key] === key ? attrs[key] : null, null);
export const clearKeySign = (obj, keySign) => Object.entries(obj).reduce((acc, _ref) => {
  let [key, val] = _ref;
  return _objectSpread(_objectSpread({}, acc), {}, {
    [key.replace(keySign, '')]: val
  });
}, {});
export const defaultTagProps = (tag, _ref2) => {
  let {
    attrs,
    content
  } = _ref2;
  return {
    tag,
    attrs: clearKeySign(attrs, '@'),
    content
  };
};
export const defaultTags = {
  b: node => defaultTagProps('strong', node),
  i: node => defaultTagProps('em', node),
  u: node => ({
    tag: 'span',
    attrs: {
      style: 'text-decoration: underline;'
    },
    content: node.content
  }),
  s: node => ({
    tag: 'span',
    attrs: {
      style: 'text-decoration: line-through;'
    },
    content: node.content
  }),
  url: node => {
    const tagProps = defaultTagProps('a', node);
    const urlKey = Object.entries(tagProps.attrs).find(_ref3 => {
      let [key, val] = _ref3;
      return key === val;
    });

    if (urlKey) {
      delete tagProps.attrs[urlKey[0]]; // eslint-disable-line

      tagProps.attrs.href = urlKey[0]; // eslint-disable-line
    }

    return tagProps;
  },
  img: (node, _ref4) => {
    let {
      render
    } = _ref4;
    const defaultProps = defaultTagProps('img', node);
    return _objectSpread(_objectSpread({}, defaultProps), {}, {
      attrs: _objectSpread(_objectSpread({}, defaultProps.attrs), {}, {
        src: render(node.content)
      }),
      content: null
    });
  },
  quote: node => defaultTagProps('blockquote', node),
  code: node => defaultTagProps('code', node)
};
export let plugins = presetHTML5.extend(tags => _objectSpread(_objectSpread({}, tags), defaultTags)); // eslint-disable-line

export const setPlugins = p => {
  plugins = p;
};

String.prototype.parseBB = // eslint-disable-line
String.prototype.parseBB || function () {
  let customPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p => p;
  return bbobHTML(this.toString(), customPlugins(plugins()));
};